import type { IconProps } from './types';
import './icons.css';

export default function DropzoneAlternative({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      height={height || 32}
      width={width || 32}
      viewBox="0 0 32 32"
      className={`dropzone-alternative ${className}`}
    >
      <path
        fill="#808589"
        d="M16.97 2.667c.361 0 .688.15.922.39l8.388 8.438c.238.236.386.565.386.928v13.659a3.24 3.24 0 0 1-3.232 3.252H8.566a3.24 3.24 0 0 1-3.233-3.252V5.919a3.24 3.24 0 0 1 3.233-3.252zM8.566 5.269a.65.65 0 0 0-.647.65v20.163c0 .36.29.65.647.65h14.868a.65.65 0 0 0 .647-.65V13.724h-5.172a3.24 3.24 0 0 1-3.232-3.252V5.269zm5.818 16.91c.714 0 1.293.583 1.293 1.302 0 .718-.579 1.3-1.293 1.3h-3.232a1.297 1.297 0 0 1-1.293-1.3c0-.719.579-1.301 1.293-1.301zm6.464 0c.714 0 1.293.583 1.293 1.302 0 .718-.579 1.3-1.293 1.3h-1.94a1.297 1.297 0 0 1-1.291-1.3c0-.719.578-1.301 1.292-1.301zm-6.464-3.577c.714 0 1.293.582 1.293 1.3s-.579 1.302-1.293 1.302h-3.232a1.3 1.3 0 0 1-1.293-1.302c0-.718.579-1.3 1.293-1.3zm6.464 0c.714 0 1.293.582 1.293 1.3s-.579 1.302-1.293 1.302h-1.94a1.297 1.297 0 0 1-1.291-1.302c0-.718.578-1.3 1.292-1.3zm-6.464-3.578c.714 0 1.293.583 1.293 1.301 0 .719-.579 1.3-1.293 1.301h-3.232a1.297 1.297 0 0 1-1.293-1.3c0-.72.579-1.302 1.293-1.302zm6.464 0c.714 0 1.293.583 1.293 1.301 0 .719-.579 1.301-1.293 1.301h-1.94a1.296 1.296 0 0 1-1.291-1.3c0-.719.578-1.301 1.292-1.302zm-2.585-4.552c0 .359.289.65.646.65h3.343l-3.989-4.014z"
      />
    </svg>
  );
}
